import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  Statistic,
  Card,
  Row,
  Col,
  Grid,
} from "antd";
import BrandColors from "@brand-colors";
import { useRewardsPageSrv } from "pages/RewardsPage/useRewardsPageSrv";
import { useMemberActivityListSrv } from "pages/Survey/useMemberActivityListSrv";
import { useDashboardsrv } from "./useDashboardsrv";
import CourouselDemo from "pages/Auth/components/CourouselDemo";
import { handleErrorNavigation } from "pages/ErrorPage/ErrorHandler";
const DashboardPage = () => {
  const navigate = useNavigate();
  const { httpGetMemberActivities } =
    useMemberActivityListSrv();
  const { httpgetMemeberBanner } = useDashboardsrv();
  const [rewardPoints, setRewardPoints] = useState([]);
  const [surveyList, setsurveyList] = useState<any>(null);
  const [giftPoints, setGiftPoints] = useState([]);
  const [formData, setFormData] = useState({ Date: "", Reason: "" });
  const [rewardCount, setRewardCount] = useState(0);
  const [giftSummary, setGiftSummary] = useState(0);
  const [remainGiftSummary, setRemainGiftSummary] = useState(0);
  const rewardService = useRewardsPageSrv();
  const [bannerData, setBannerData] = useState<any>("");
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { t } = useTranslation();
  useEffect(() => {
    httpgetMemeberBanner().then((res) => {      
        setBannerData(res?.data);
    });
  }, []);
  useEffect(() => {
    const fetchRewardList = async () => {
      try {
        const resReward = await rewardService.httpgetGiftCardDetails(
          formData.Date,
          formData.Reason
        );
        console.log("resReward", resReward.data);
        if (Array.isArray(resReward.data)) {
          setRewardPoints(resReward.data);
          setRewardCount(findSum(resReward.data, "reward"));
          console.log("rewards", findSum(resReward.data, "rewards"));
        } else {
          console.error("Reward data is not an array:", resReward.data);
        }
      } catch (e) {
        handleErrorNavigation(e, navigate, t)
        console.error("Error fetching reward list:", e);
      }
    };

    const fetchGiftCardDetails = async () => {
      try {
        const resGift = await rewardService.httpgetGiftCardDetails(
          formData.Date,
          formData.Reason
        );
        setGiftPoints(resGift ? resGift.data : "");
        setGiftSummary(findSum(resGift ? resGift.data : "", "giftcard"));
        setRemainGiftSummary(findRemain(resGift ? resGift.data : ""));
        console.log("gifts", findSum(resGift ? resGift.data : ""));
      } catch (e) {
        handleErrorNavigation(e, navigate, t)
      }
    };

    fetchRewardList();
    fetchGiftCardDetails();
  }, [formData]);
  useEffect(() => {
    httpGetMemberActivities()
      ?.then((res) => {
        console.log("res.data", res.data);
        let rueBasedActivities = res.data.filter(function (item: any) {
          return item.IsRuleBasedSurvey == true;
        });
        console.log("rueBasedActivities", rueBasedActivities);
        setsurveyList(rueBasedActivities);
      })
      .catch((e) => {
        handleErrorNavigation(e, navigate, t)
      });
  }, []);
  console.log("giftSummary2", giftSummary);
  const findSum = (data, type) => {
    let total = 0;
    let redeem = 0;
    console.log("data", data);

    for (let i = 0; i < data?.length; i++) {
      console.log("data[i]", data[i]);
      if (data[i].RewardType == 120000007) {
        total +=
          data[i].RewardValue && data[i].RewardValue > 0
            ? data[i].RewardValue
            : 0;
      } else if (data[i].RewardType == 120000003) {
        total +=
          data[i].RewardValue && data[i].RewardValue > 0
            ? data[i].RewardValue
            : 0;
      }
    }

    return type == "reward" ? redeem : type == "giftcard" ? total : 0;
  };
  const findRemain = (data) => {
    let remainGiftPoint = 0;
    for (let j = 0; j < data?.length; j++) {
      if (data[j].RewardType === "120000003") {
        if (data[j].RewardValueStatus === "120000000") {
          remainGiftPoint += data[j].RewardValue;
        }
      }
    }
    return remainGiftPoint;
  };
  const openReward = () => {
    navigate("/member/rewardspage");
  };

  const openGift = () => {
    navigate("/member/activities");
  };
  return (
    <>
      <Card
        bordered={false}
        style={{
          borderRadius: "0px",
        }}
      >
        <div>
          {bannerData && bannerData.length > 0 ? (
            <div style={{ marginBottom: "35px" }}>
            <CourouselDemo bannerData={bannerData} />
            </div>
          ) : (
            ""
          )}
        </div>
        <div>
          <div data-testid="dashboard-page">
            {" "}
            <div className="section-container">
              <Row gutter={0}>
                <Col span={24}>
                  <Card
                    bordered={false}
                    style={{
                      backgroundColor: BrandColors.HEADER_BG,
                      color: "#fff",
                      borderRadius: "4px",
                      textAlign: "center",
                    }}
                  >
                    <div
                      style={{ display: "flex", justifyContent: "space-between" }}
                    >
                      <div
                        style={{ flex: 1 }}
                        onClick={openReward}
                        data-testid="rewards-total"
                      >
                        {" "}
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                          }}
                        >
                          <Statistic valueStyle={{ color: '#fff', fontSize: screens.lg ? "40px" : "25px", fontWeight: "bold" }}
                            value={`$ ${remainGiftSummary} / ${giftSummary}`}
                          />

                          <p style={{ fontWeight: 400, fontSize: screens.lg ? "20px" : "16px", margin: "0" }}>
                            {t("DASHBOARD.LABEL_GIFTS_TOTAL")}
                          </p>
                        </div>
                      </div>
                      <div
                        style={{ flex: 1 }}
                        onClick={openGift}
                        data-testid="gifts-total"
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                          }}
                        >
                          <Statistic value={surveyList?.length} valueStyle={{ color: '#fff', fontSize: screens.lg ? "40px" : "25px", fontWeight: "bold" }} />
                          <p style={{ fontWeight: 400, fontSize: screens.lg ? "20px" : "16px", margin: "0" }}>
                            {t("DASHBOARD.SUMMARY_DESC")}
                          </p>
                        </div>
                      </div>
                    </div>
                  </Card>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </Card>
    </>
  );
};
export default DashboardPage;
